import React, { useState } from 'react';
import SubmitButton from './SubmitButton';
import Spinner from './Spinner';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const CheckInventory = ({ location }) => {
    const [barcode, setBarcode] = useState('');
    const [productData, setProductData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleInputChange = (e) => {
        setBarcode(e.target.value);
        setError('');
    };

    const handleCheckInventory = () => {
        if (!barcode) {
            setError('Please enter a product barcode.');
            return;
        }

        setLoading(true);
        setError('');
        setProductData(null);

        // Fetch product details and location quantities
        Promise.all([
            fetch(`${API_URL}/product/${barcode}`).then(res => res.json()),
            fetch(`${API_URL}/product-location/${barcode}`).then(res => res.json())
        ])
            .then(([productInfo, locationInfo]) => {
                setLoading(false);
                
                if (productInfo.error) {
                    setError('Product not found');
                    return;
                }

                // Get location-specific data based on selected location
                let locationData = {};
                let totalQty = 0;

                if (location === 'trueliberty') {
                    locationData = {
                        'TL UP': locationInfo.TL_UP || 0,
                        'TL DOWN-R': locationInfo.TL_DOWN_R || 0,
                        'TL DOWN-C': locationInfo.TL_DOWN_C || 0,
                        'TL DOWN-L': locationInfo.TL_DOWN_L || 0
                    };
                    totalQty = productInfo.TL || 0;
                } else if (location === 'royaltech') {
                    locationData = {
                        'RoyalTech Main': productInfo.RT || 0
                    };
                    totalQty = productInfo.RT || 0;
                } else if (location === 'stores') {
                    // This is for when we add a combined stores view later
                    locationData = {
                        'Shuwaikh Store': productInfo.SHUWAIKH_STORE || 0,
                        'Bahman Store': productInfo.BAHMAN_STORE || 0
                    };
                    totalQty = (productInfo.SHUWAIKH_STORE || 0) + (productInfo.BAHMAN_STORE || 0);
                } else if (location === 'bahman') {
                    // Bahman Store with rack breakdown
                    locationData = {
                        'BAHMAN RACK 1': locationInfo.BAHMAN_RACK_1 || 0,
                        'BAHMAN RACK 2': locationInfo.BAHMAN_RACK_2 || 0,
                        'BAHMAN RACK 3': locationInfo.BAHMAN_RACK_3 || 0,
                        'BAHMAN RACK 4': locationInfo.BAHMAN_RACK_4 || 0,
                        'BAHMAN RACK 5': locationInfo.BAHMAN_RACK_5 || 0
                    };
                    totalQty = productInfo.BAHMAN_STORE || 0;
                } else if (location === 'shuwaikh') {
                    // Shuwaikh Store with rack breakdown
                    locationData = {
                        'SHUWAIKH RACK 1': locationInfo.SHUWAIKH_RACK_1 || 0,
                        'SHUWAIKH RACK 2': locationInfo.SHUWAIKH_RACK_2 || 0,
                        'SHUWAIKH RACK 3': locationInfo.SHUWAIKH_RACK_3 || 0
                    };
                    totalQty = productInfo.SHUWAIKH_STORE || 0;
                }

                setProductData({
                    description: productInfo.description,
                    brand: productInfo.brand,
                    unit: productInfo.unit,
                    locations: locationData,
                    total: totalQty
                });
            })
            .catch((err) => {
                setLoading(false);
                console.error('Error fetching inventory:', err);
                setError('Failed to fetch inventory details.');
            });
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleCheckInventory();
        }
    };

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                maxWidth: '800px',
                margin: '20px auto',
                textAlign: 'center',
            }}
        >
            <div
                style={{
                    width: '80%',
                    padding: '20px',
                    border: '2px solid #ddd',
                    borderRadius: '8px',
                    backgroundImage: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                }}
            >
                <h2 style={{ color: '#fff', marginTop: 0 }}>Check Inventory</h2>
                
                <div style={{ marginBottom: '20px' }}>
                    <input
                        type="text"
                        placeholder="Enter Barcode"
                        value={barcode}
                        onChange={handleInputChange}
                        onKeyPress={handleKeyPress}
                        inputMode="numeric"
                        style={{
                            padding: '10px',
                            fontSize: '16px',
                            width: '200px',
                            border: '2px solid black',
                            borderRadius: '5px',
                            marginRight: '10px',
                        }}
                    />
                    <SubmitButton onClick={handleCheckInventory} label="Check" />
                </div>

                {error && (
                    <div style={{
                        color: '#fff',
                        backgroundColor: 'rgba(255, 0, 0, 0.3)',
                        padding: '10px',
                        borderRadius: '5px',
                        marginBottom: '10px'
                    }}>
                        {error}
                    </div>
                )}

                {loading && <Spinner />}

                {productData && !loading && (
                    <div
                        style={{
                            marginTop: '20px',
                            padding: '15px',
                            border: '2px solid black',
                            borderRadius: '5px',
                            backgroundColor: '#f9f9f9',
                            textAlign: 'left',
                        }}
                    >
                        <div style={{ marginBottom: '15px', borderBottom: '2px solid #ddd', paddingBottom: '10px' }}>
                            <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>Product Information</h3>
                            <p style={{ margin: '5px 0' }}><strong>Description:</strong> {productData.description}</p>
                            <p style={{ margin: '5px 0' }}><strong>Brand:</strong> {productData.brand}</p>
                            <p style={{ margin: '5px 0' }}><strong>Unit:</strong> {productData.unit}</p>
                        </div>

                        {productData.locations && (
                            <div style={{ marginBottom: '15px' }}>
                                <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>Location Quantities</h3>
                                <div style={{ 
                                    display: 'grid', 
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', 
                                    gap: '10px',
                                    fontSize: '14px'
                                }}>
                                    {Object.entries(productData.locations).map(([locationName, qty]) => (
                                        <div key={locationName} style={{ 
                                            padding: '8px', 
                                            backgroundColor: '#e8f4f8', 
                                            borderRadius: '4px' 
                                        }}>
                                            <strong>{locationName}:</strong> {qty}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        <div style={{ 
                            marginTop: '15px',
                            padding: '10px',
                            backgroundColor: '#4CAF50',
                            color: '#fff',
                            borderRadius: '5px',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            textAlign: 'center'
                        }}>
                            Total Inventory: {productData.total}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CheckInventory;